export default __webpack_public_path__ + "static/media/expert_buying.017e100f.svg";